<template>
  <div class="debugging-helper">
    <div class="debugging-helper__items">
      <button
        v-for="({ label, onClick, testId }, index) in controls"
        :key="`${label}-${index}`"
        class="debugging-helper__item"
        :test-id="testId"
        @click="onClick"
      >
        {{ label }}
      </button>
    </div>
    <div class="debugging-helper__items">
      <span
        v-for="{ label, testId, data } in statistics"
        :key="label"
        class="debugging-helper__item"
      >
        {{ label }}:
        <span :test-id="testId">{{ data }}</span>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useBoardStore } from '@/stores/useBoardStore'

const boardStore = useBoardStore()

const controls = [
  {
    label: 'Prev',
    testId: 'prev-button',
    onClick: boardStore.prevBoard
  },
  {
    label: 'Next',
    testId: 'next-button',
    onClick: boardStore.nextBoard
  },
  {
    label: 'Start',
    testId: 'start-carousel-button',
    onClick: boardStore.startSlider
  },
  {
    label: 'Stop',
    testId: 'stop-carousel-button',
    onClick: boardStore.stopSlider
  }
]

const statistics = computed(() => [
  {
    label: 'Current',
    testId: 'current-board',
    data: boardStore.currentBoardIndex + 1
  },
  {
    label: 'Total',
    testId: 'total-boards',
    data: boardStore.boards.length
  },
  {
    label: 'Loop',
    testId: 'loop-counter',
    data: boardStore.loopCount
  }
])
</script>

<style lang="scss" scoped>
.debugging-helper {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;

  &__items {
    display: flex;
    gap: 8px;
    color: white;
  }

  &__item {
    padding: 5px 20px;
    font-size: vh(36px);
    color: white;
    background-color: #000000;
  }
}
</style>
